// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2TbwK","imageUploader":"EGiftCard_imageUploader__On9EJ"};